module.exports = "../../app/cells/pages/contests/index/cta_list_contest_cell.rb";